import React, { Component } from 'react';
import { Icon } from 'react-materialize';


class CountrySourcesCollapsible extends Component {
  constructor(props) {
   super(props);
   this.state = {
     collapsible: true
   }
 }

 onClickCollapsible(){
   let temp = this.state.collapsible;
   this.setState({ collapsible: !temp })
 }



render() {
  return (
  <div className="map-view-collapsible">
    <div className="map-view-collapsible-title" onClick={() => this.onClickCollapsible()}>
      <div className="view-text">
        Country Resources
      </div>
      <div className="view-icon">
        {
          this.state.collapsible? <Icon>keyboard_arrow_up</Icon>:<Icon>keyboard_arrow_down</Icon>
        }
      </div>
    </div>
    <div>
      {
        this.state.collapsible? <div>information to be added</div>: ""
      }
    </div>
  </div>
  )}
}

export default CountrySourcesCollapsible;



// WEBPACK FOOTER //
// ./src/components/CountrySourcesCollapsible.js